export default {
	searchParams: SEARCH_PARAMS(),
	compList: [],

	pagingInfo: PAGING_INFO()
};

function SEARCH_PARAMS() {
	return {
		cpnyCd: '',
		cpnyNm: '',
		cpnyScn: ''
	};
}

function PAGING_INFO() {
	return {
		currentPage: 1,
		endPage: 1,
		pageUnit: 30,
		startPage: 1,
		totalSize: 1
	};
}

export { SEARCH_PARAMS, PAGING_INFO };
